import type { Storage as IStorage, Files as IFiles, Haptics as IHaptics, Share as IShare, DeepLink as IDeepLink } from "@cobu/platform";

export const Storage: IStorage = {
  async get(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  async set(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {}
  },
  async del(key) {
    try {
      localStorage.removeItem(key);
    } catch {}
  },
};

export const Files: IFiles = {
  pick(opts = {}) {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      if (opts.accept) input.accept = opts.accept;
      if (opts.multiple) input.multiple = true;
      input.onchange = () => {
        const files = input.files ? Array.from(input.files) : null;
        resolve(files);
      };
      input.click();
    });
  },
};

export const Haptics: IHaptics = {
  impact() {
    // no-op on web
  },
};

async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
}

export const Share: IShare = {
  async share({ title, text, url }) {
    const payload: ShareData = { title, text, url };
    if (navigator.share) {
      try {
        await navigator.share(payload);
        return;
      } catch {}
    }
    await copyToClipboard([title, text, url].filter(Boolean).join("\n"));
  },
};

export const DeepLink: IDeepLink = {
  open(url: string) {
    window.location.href = url;
  },
  toPath(appLink: string) {
    // naive mapping; customize later
    return appLink.replace(/^cobu:\/\//, "/");
  },
};


